import toString from './to-string';

const upperCase = function(str: string): string {
  return toString(str).toUpperCase();
};

export default upperCase;
